import { isValidObject } from 'helpers/validation';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import exportUtil from './export';
import service from './service';
import constants from '../constants';
import styled from '../components/TableComponents/Cell/styled';
import text from 'strings/text';

const addShiftText = (date) => {return <FormattedMessage id="AddShiftComponent.addAShift" defaultMessage="Add a Shift on {value}" values={{ value: date?.format('ddd, MMM DD') }} />; }
const viewShiftText = (date) => {return <FormattedMessage id="AddShiftComponent.viewShift" defaultMessage="Shift on {value}" values={{ value: date?.format('ddd, MMM DD') }} />; }
const jobTitleText = () => {return <FormattedMessage id="ShiftRow.jobTitle" defaultMessage="Position" />;}
const assignToText = () => {return <FormattedMessage id="ShiftRow.assignTo" defaultMessage="Assign To" />;}
const timeText = () => {return <FormattedMessage id="TimePicker.startTimeLabel" defaultMessage="Time" />; }
const applyToText = () => {return <FormattedMessage id="AddShiftComponent.applyTo" defaultMessage="Apply To:" />; } 
const overnightShiftText = () => {return <FormattedMessage id="ViewShifts.overnightExplain" defaultMessage="This is an overnight shift." />;}
const longTitleWarningText = () => { return <FormattedMessage id="AddShiftComponent.jobTitleTooLong" defaultMessage="Position is too long." />;} 

const saveText = () =>  { return <FormattedMessage id="ShiftDetail.save" defaultMessage='Save' />; }
const cancelText = () => { return <FormattedMessage id="ShiftDetail.cancel" defaultMessage='Cancel' />; }
const addShiftString = () => { return <FormattedMessage id="ShiftDetail.addShift" defaultMessage='Add Shift' />; }
const addVTOString = () => { return <FormattedMessage id="ShiftDetail.addVTO" defaultMessage='Add VTO' />; }

const groupPlaceholderText = () => { return <FormattedMessage id="ShiftDetail.groupPlaceholder" defaultMessage='Select the group that will see this shift' />; }

const hasAppliedForOpenShift = () => { return <FormattedMessage id="ShiftDetail.appliedForOS" defaultMessage='has applied to cover an open shift' />; } 
const isApprovedForOpenShift = () => { return <FormattedMessage id="ShiftDetail.approvedForOS" defaultMessage='has been approved to cover this open shift' />; } 
const deniedForOpenShift = () => { return <FormattedMessage id="ShiftDetail.deniedForOS" defaultMessage='has been denied to cover this open shift' />; } 

const hasAppliedForVTO = () => { return <FormattedMessage id="ShiftDetail.appliedForVTO" defaultMessage='has applied to take VTO' />; } 
const isApprovedForVTO = () => { return <FormattedMessage id="ShiftDetail.approvedForVTO" defaultMessage='has been approved to take VTO' />; } 
const deniedForVTO = () => { return <FormattedMessage id="ShiftDetail.deniedForVTO" defaultMessage='has been denied to take VTO' />; } 

const hasAppliedToCoverShift = () => { return <FormattedMessage id="ShiftDetail.appliedForThisShift" defaultMessage='has applied to cover this shift' />; } 
const approvedForThisShift = () => { return <FormattedMessage id="ShiftDetail.approvedForThisShift" defaultMessage='has been approved to cover this shift' />; } 
const deniedForThisShift = () => { return <FormattedMessage id="ShiftDetail.deniedForThisShift" defaultMessage='has been denied to cover this shift' />; } 

const pendingX = (count) => { return <FormattedMessage id="ShiftDetail.pendingX" defaultMessage='Pending ({value})' values={{value: count}}/>; } 
const approvedX = (count) => { return <FormattedMessage id="ShiftDetail.approvedX" defaultMessage='Approved ({value})' values={{value: count}}/>; } 
const deniedX = (count) => { return <FormattedMessage id="ShiftDetail.deniedX" defaultMessage='Denied ({value})' values={{value: count}}/>; } 

const messageX = (name) => { return 'Message '+ name }
const sendApplicantCommentText = () => { return 'Send an applicant comment...' }

const textHours = (hours) => {return <FormattedMessage id="DayCell.hours" defaultMessage="{value} h" values={{ value: hours }} />};
const pasteShift = () => {return <FormattedMessage id="AddShiftComponent.pasteShift" defaultMessage="Paste Shift" />};
const pasteVTO = () => {return <FormattedMessage id="AddShiftComponent.pasteVTO" defaultMessage="Paste VTO" />};

const approvedText = () => { return <FormattedMessage id="AddShiftComponent.approved" defaultMessage="APPROVED" />; }
const deniedText = () => { return <FormattedMessage id="AddShiftComponent.denied" defaultMessage="DENIED" />; }
const pendingText = () => { return <FormattedMessage id="AddShiftComponent.pending" defaultMessage="PENDING" />; }  
const calledOffText = () => { return <FormattedMessage id="AddShiftComponent.calledOff" defaultMessage="CALLED OFF" />; }
const postedText = () => { return <FormattedMessage id="AddShiftComponent.posted" defaultMessage="POSTED" />; }
const coveredText = () => { return <FormattedMessage id="AddShiftComponent.covered" defaultMessage="COVERED" />; }

const createShiftOnText = (date) => { return <FormattedMessage id="ShiftDetail.createShiftOn" defaultMessage='Create Shift on {shiftDate}' values={{shiftDate: date}} />; }
const createVTOOnText = (date) => { return <FormattedMessage id="ShiftDetail.createVTOOn" defaultMessage='Create VTO on {shiftDate}' values={{shiftDate: date}} />; }

const deleteShiftText = () => {return <FormattedMessage id="Scheduling.deleteShiftTitle" defaultMessage="Delete Shift?" />};
const deleteVTOText = () => {return <FormattedMessage id="Scheduling.deleteVTOTitle" defaultMessage="Delete VTO?" />};

const deleteShiftBodyText = () => {return <FormattedMessage id="Scheduling.deleteShiftBody" defaultMessage="Are you sure you want to delete this shift? This action cannot be undone." />};
const deleteVTOBodyText = () => {return <FormattedMessage id="Scheduling.deleteVTOBody" defaultMessage="Are you sure you want to delete this VTO? This action cannot be undone." />};

const deleteTitleText = (subtype) => {
  if( subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO || subtype == constants.ShiftSubType.ChildVTO ){
    return deleteVTOText();
  }else{
    return deleteShiftText();
  }
}

const deleteBodyText = (subtype) => {
  if( subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO || subtype == constants.ShiftSubType.ChildVTO ){
    return deleteVTOBodyText();
  }else{
    return deleteShiftBodyText();
  }
}

const detailsText = (subtype) => {
  if( subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO || subtype == constants.ShiftSubType.ChildVTO ){
    return text.vtoDetails();
  }else{
    return text.shiftDetails();
  }
}

const labelForPillTag = (subtype) => {
  if( subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO || subtype == constants.ShiftSubType.ChildVTO ){
    return 'VTOs';
  }else{
    return 'Shifts';
  }
}

const addObjectText= (creationType) => {
  if( creationType == constants.ShiftCreationType.VTO ){
    return addVTOString();
  }else{
    return addShiftString();
  }
}

const descriptionText = (subtype, creationType) => {
  if( creationType == constants.ShiftCreationType.VTO || subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO || subtype == constants.ShiftSubType.ChildVTO ){
    return text.vtoDescription();
  }else{
    return text.shiftDescription();
  }
}

const copyText = (subtype) =>  { 
  if ( subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO || subtype == constants.ShiftSubType.ChildVTO ){
    return text.copyVTOText();
  }else{
    return text.copyShiftText();
  }
}

const deleteText = (subtype) => { 
    if ( subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO || subtype == constants.ShiftSubType.ChildVTO ){
      return text.deleteVTOText();
    }else{
      return text.deleteShiftText();
    }
  }

const createTitleText = (creationType, date) => {
  if ( creationType == constants.ShiftCreationType.VTO ){
    return createVTOOnText(date);
  }else{
    return createShiftOnText(date);
  }
}

const cardClassNameForShift = (shift) => {
    if( shift.trade_status === 'inventory' ) {
        return constants.CardClassName.card_inventory;
    }else if ( shift.trade_status === 'called_off') {
        return constants.CardClassName.card_called_off;
    // Team Shift
    }else if ( shift.name === 'shift' ) {
      if( shift.trade_status === 'covered' || shift.trade_status === 'approved' ) {
        return constants.CardClassName.card_approved;
      }else if ( shift.trade_status === 'posted'){
        return cardClassNameForPostedShift(shift);
      }else if ( shift.trade_status === 'pending'){
        return constants.CardClassName.card_pending;
      }else if ( shift.trade_status === 'rejected'){
        return constants.CardClassName.card_inventory;
      }
    // Open Shift
    }else if ( shift.name == 'open_shift' ) {
      if( shift.trade_status == 'approved' || shift.trade_status == 'covered' )  {
        return constants.CardClassName.card_approved;
      }else {
        return constants.CardClassName.card_posted;
      }
    }else if ( shift.name == 'shift_vto' ) {
      if( shift.trade_status == 'approved' || shift.trade_status == 'covered' )  {
        return constants.CardClassName.card_approved;
      }else {
        return constants.CardClassName.card_posted;
      }
    }else {
        return constants.CardClassName.card_unpublished;
    }
}

const cardClassNameForPostedShift = (shift) => {
    if( isValidObject(shift) == false ) { return '' }
    
    if( shift.cover_mode == 'multi_applicants_picked_by_manager') {
        let approveCount = shift.current_applicants_picked_user_ids?.length || 0
        let pendingCount = shift.current_applicants_pending_user_ids?.length|| 0
        let nominatedCount = shift.current_applicants_nominated_user_ids?.length|| 0
        
        if ( pendingCount > 0 ) {
            return constants.CardClassName.card_pending;
        }else if ( nominatedCount > 0 ) {
            return constants.CardClassName.card_pending;
        }else if (approveCount > 0 ){
            return constants.CardClassName.card_approved;
        }
    }
    return constants.CardClassName.card_posted;
}

const cardClassNameForOpenShift = (shift) => {
    if( shift.name == 'open_shift' ){
        if( shift.parent_card == true) {
            if ( hasPendingApplicants(shift) == true ){
                return 'card_pending';
            }else if ( areAllSlotsFilled(shift) == true ){
                return "card_approved";
            }else if ( shift.trade_status == 'unpublished_posted' ){
                return 'card_unpublished';
            }else{
                return 'card_posted';
            }
        }
    }
    return 'card_unpublished';
}

const cardClassNameForVTO = (shift) => {
    if( shift.name == 'shift_vto' ){
        if( shift.parent_card == true) {
            if ( hasPendingApplicants(shift) == true ){
                return 'card_pending';
            }else if ( areAllSlotsFilled(shift) == true ){
                return "card_approved";
            }else if ( shift.trade_status == 'unpublished_posted' ){
                return 'card_unpublished';
            }else{
                return 'card_posted';
            }
        }
    }
    return 'card_unpublished';
}

const shouldShowStatusTag = (className) => {
    if ( className == constants.CardClassName.card_called_off ){
        return true;
    }else if ( className == constants.CardClassName.card_approved ){
        return true;
    }else if ( className == constants.CardClassName.card_posted){
        return true;
    }else if ( className == constants.CardClassName.card_pending){
        return true;
    }else {
        return false;
    }
}

const shouldShowSectionTab = (shiftObject) => {
    if ( isValidObject(shiftObject) == true && (shiftObject?.name == 'open_shift' || shiftObject?.name == 'shift_vto') && shiftObject?.trade_status != 'unpublished_posted' ){
        return true;
    }else{
        return false;
    } 
}

const tagTextForShiftCard = (shiftObject) => {
    var tagText = '';

    if ( shiftObject.name === 'shift' ) {
        if( shiftObject?.trade_status == 'covered') {
            tagText = coveredText();
        }else if ( shiftObject?.trade_status == 'approved' ) {
            tagText = approvedText();
        }else if ( shiftObject?.trade_status == 'pending' ){
            tagText = pendingText();
        }else if ( shiftObject?.trade_status == 'posted' ){
            tagText = cohortPostedStatusTag(shiftObject);
        }
    }else if (shiftObject?.name === 'shift_inventory' ){
        if (shiftObject?.trade_status === 'called_off'){
        tagText = calledOffText();
        }
    }else {
        const subtype = service.getShiftSubType(shiftObject)
        if( subtype == constants.ShiftSubType.ChildOpenShift || subtype == constants.ShiftSubType.ChildVTO ){
            if( shiftObject?.trade_status == 'approved' ){
                tagText = approvedText();
            }
        }
    }
    return tagText;
}

const cohortPostedStatusTag = (shift) => {
    if( isValidObject(shift) == false ) { return '' }
    
    if( shift.cover_mode == 'multi_applicants_picked_by_manager') {
        let approveCount = shift.current_applicants_picked_user_ids?.length || 0
        let pendingCount = shift.current_applicants_pending_user_ids?.length|| 0
        let denyCount = shift.current_applicants_denied_user_ids?.length || 0
        let nominatedCount = shift.current_applicants_nominated_user_ids?.length|| 0
        
        if ( pendingCount > 0 ) {
            return pendingText();
        }else if ( nominatedCount > 0 ) {
            return pendingText();
        }else if (approveCount > 0 ){
            return approvedText();
        }
    }
    return postedText();
}

const hasPendingApplicants = (shiftObject) => {
    return shiftObject.current_applicants_pending_user_ids && shiftObject.current_applicants_pending_user_ids.length > 0 ;
}

const areAllSlotsFilled = (shiftObject) => {
    return shiftObject.current_applicants_picked_user_ids && shiftObject.current_applicants_picked_user_ids.length >= shiftObject.total_shifts_available;
}

const shouldShowPosterAvatar = (shiftObject) => {
    if ( shiftObject?.name == 'shift' && ( shiftObject?.trade_status == 'posted' || shiftObject?.trade_status == 'pending' || shiftObject?.trade_status == 'approved' || shiftObject?.trade_status == 'covered' )){
        return true;
    }else{
        return false;
    }
}

const shouldShowTakerAvatar = (shiftObject) => {
    if ( shiftObject?.name == 'shift' && ( shiftObject?.trade_status == 'pending' || shiftObject?.trade_status == 'approved' || shiftObject?.trade_status == 'covered' ) ) {
        return true;
    }else{
        return false;
    }
}

const userAvatarPlaceholder = () => { return '/icons/default-profile-thumb.svg'; }
const openShiftSelectionTarget = () => { return {assignToOpenShift: true, profile_image_thumb_url: '/icons/open-plus.svg', first_name: 'Open', last_name: 'Shift', id: 0}; }
const vtoSelectionTarget = () => { return {assignToVTO: true, profile_image_thumb_url: '/icons/vto-sign.svg', first_name: 'Voluntary', last_name: 'Time Off', id: -1}; }

const posterAvatar = (shiftObject, allUsers) => {
    const poster = getPoster(shiftObject, allUsers);
    return getUserAvatar(poster);
}

const takerAvatar = (shiftObject, allUsers) => {
    const taker = getTaker(shiftObject, allUsers);
    return getUserAvatar(taker);
}

const getUserAvatar = (user) => {
    var url = user?.profile_image_thumb_url;
        if( isValidObject(url) == false ){
            url = userAvatarPlaceholder()
        }
    return url;
}

const getName = (user) => {
    if( typeof user != 'undefined' && user !== null ){
        const userName = (user.hasOwnProperty('fullName')) ? user.fullName : (`${user.first_name} ${user.last_name}`); 
        return userName;
    }else{
        return '';
    }
}

const getPosterName = (shiftObject, allUsers) => {
    const user = getPoster(shiftObject, allUsers);
    return getName(user);
}

const getTakerName = (shiftObject, allUsers) => {
    const taker = getTaker(shiftObject, allUsers);
    return getName(taker);
}

const getPoster = (shiftObject, allUsers) => {
    if ( isValidObject(shiftObject) == true ){
        return getUserFromId(shiftObject.owner_id, allUsers);   
    }else{
        return null
    }
}

const getTaker = (shiftObject, allUsers) => {
    return getUserFromId(shiftObject.coverer_id, allUsers);
}

const getUserFromId = (userId, allUsers) => {
    const user = allUsers.filter((user) => user.owner_id == userId);
    return user[0];
}

const xCoveringForYText = (user, currentShift, allUsers) => {
    const userName = getTakerName(currentShift, allUsers);
    const posterName = getPosterName(currentShift, allUsers);
    var result='';

    if( (currentShift.trade_status === 'covered' || currentShift.trade_status === 'approved') ) {
        result = (<FormattedMessage id="PopupDialogViewShifts.xCoveringShiftForY" defaultMessage="{userName} is covering this shift for {posterUserName}." values={{ userName: userName, posterUserName: posterName}} />);
    }else if ( currentShift.trade_status === 'pending' ){
        result = (<FormattedMessage id="PopupDialogViewShifts.xAppiedToCoverXShift" defaultMessage="{userName} has applied to cover {posterUserName}'s shift." values={{ userName: userName, posterUserName: posterName}} />);
    }
    return result;    
}

const getGroupName = (shiftObject, channels) => {
    return getGroup(shiftObject, channels)?.channel_name || '';
}

const getGroupId = (shiftObject, channels) => {
    return getGroup(shiftObject, channels)?.id || '';
}

const getGroup = (shiftObject, channels) => {
    const channelId = shiftObject.channel_id;
    const channel = channels.filter((channel) => channel.id == channelId);
    if( channel?.length > 0){
        return channel[0];
    }else{
        return null;
    } 
}

const applicantAvatar = (applicant) => {
    const placeholder = userAvatarPlaceholder();
    if ( isValidObject(applicant) == false) { return placeholder }
    const user = applicant.user;
    var avatarUrl = (user?.thumb_url || placeholder)
    return avatarUrl;
}

const getApplicantName = (applicant) => {
    const user = applicant?.user;
    return user?.first_name + ' ' + user?.last_name ;
}

const getApplicantFirstName = (applicant) => {
    const user = applicant?.user;
    const name = user?.first_name;
    if( isValidObject(name) == false ){
        return '';
    }else{
        return ' ' + name;
    }
}

const getNameFromApplicantOrUserId = (applicant, userId, allUsers) => {
    if ( isValidObject(applicant) == true ){
        return getApplicantName(applicant)
    }else{
        const user = getUserFromId(userId, allUsers)
        return getName(user)
    }
}

const getApplicantPosition = (applicant) => {
    const user = applicant?.user;
    return user?.current_position || '';
}

const getApplicantNameAndPosition = (applicant) => {
    const name = getApplicantName(applicant);
    const pos = getApplicantPosition(applicant);
    if( isValidObject(pos) == true && pos.length > 0 ) {
        return name + ' • ' + pos;
    }else{
        return name;
    }
}

const getOpenShiftApplicantTagline = (applicant) => {
    if ( applicant?.status == 'applied' || applicant?.status == 'nominated' ){ 
        return hasAppliedForOpenShift();
    }else if (applicant?.status == 'picked' ){
        return isApprovedForOpenShift();
    }else if ( applicant?.status == 'denied' ){
        return deniedForOpenShift();
    }
}

const getVTOApplicantTagline = (applicant) => {
    if ( applicant?.status == 'applied' || applicant?.status == 'nominated' ){ 
        return hasAppliedForVTO();
    }else if (applicant?.status == 'picked' ){
        return isApprovedForVTO();
    }else if ( applicant?.status == 'denied' ){
        return deniedForVTO();
    }
}

const getTeamShiftApplicantTagline = (applicant) => {
    if ( applicant?.status == 'applied' || applicant?.status == 'nominated' ){  
        return hasAppliedToCoverShift();
    }else if ( applicant?.status == 'picked' ){
        return approvedForThisShift();
    }else if ( applicant?.status == 'denied' ){
        return deniedForThisShift();
    }
}

const getApplicantTagline = (shift, applicant) => {
    if( shift.name == 'open_shift' ){
        return getOpenShiftApplicantTagline(applicant);
    }else if ( shift.name == 'shift_vto' ){
        return getVTOApplicantTagline(applicant);
    }else if ( shift.name == 'shift' ){
        return getTeamShiftApplicantTagline(applicant);
    }else{
        return getApplicantPosition(applicant)
    }
}

const visibilityClassName = (shouldShow) => {
    if( shouldShow == true ) {
        return 'shown';
    }else{ 
        return 'hidden';
    }
}

const userShiftIsAssignedTo = (shift, allUsers, unregisteredUsers) => {
    if( shift.trade_status == 'unregistered_user_shift_inventory' || shift.trade_status == 'unregistered_unpublished_inventory' ){
        return exportUtil.getUnregisteredUserInfo(shift, unregisteredUsers) 
    }else{
        return getUserFromId(shift.taker_id, allUsers)
    }
}

const applicantNumberText = (count) => {
    return <FormattedMessage id="ShiftDetail.applicantX" defaultMessage='Applicants ({value})' values={{value: count}}/>;  
}

const pasteShiftCell = (onPasteClick, onEmptyCellMouseEnter, onEmptyCellMouseLeave, isMouseOverCell, isVTO) => {
    return (<div className="day-cell-top-wrap"
                onMouseUpCapture={onPasteClick}
                onMouseEnter={onEmptyCellMouseEnter}
                onMouseLeave={onEmptyCellMouseLeave} >
 
                <div className="day-cell" display='block'>
                <styled.PasteShiftWrap display={isMouseOverCell ? 'block' : 'none'}>{isVTO ? pasteVTO() : pasteShift()}</styled.PasteShiftWrap>
                </div>
            </div>);
}

const addNewShiftCell = (onCellClick, onEmptyCellMouseEnter, onEmptyCellMouseLeave, isMouseOverCell) => {
    return (
        <div className="add-shift-wrap"
          onMouseUpCapture={onCellClick}
          onMouseEnter={onEmptyCellMouseEnter}
          onMouseLeave={onEmptyCellMouseLeave} >

          <div className="day-cell" display='flex'>
            <styled.NotScheduledWrap display={isMouseOverCell ? 'block' : 'none'}> <img src='/icons/round_plus_button.svg'/> </styled.NotScheduledWrap>
          </div>
        </div>
      );
}

const notScheduledCell = (shifts, isCopyingShift, shiftToCopy, onPasteClick, onCellClick, onEmptyCellMouseEnter, onEmptyCellMouseLeave, isMouseOverCell) => {

  if ( isValidObject(shifts) == false || shifts.length === 0) {
    if (isCopyingShift && shiftToCopy !== null) {

      return (
        <div className="day-cell-top-wrap"
          onMouseUpCapture={onPasteClick}
          onMouseEnter={onEmptyCellMouseEnter}
          onMouseLeave={onEmptyCellMouseLeave} >
       
          <div className="day-cell" display='block'>
            <styled.PasteShiftWrap display={isMouseOverCell ? 'block' : 'none'}>{presenter.pasteShift()}</styled.PasteShiftWrap>
          </div>
        </div>
      );
    } else {
      return (
        <div className="add-shift-wrap"
          onMouseUpCapture={onCellClick}
          onMouseEnter={onEmptyCellMouseEnter}
          onMouseLeave={onEmptyCellMouseLeave} >

          <div className="day-cell" display='flex'>
            <styled.NotScheduledWrap display={isMouseOverCell ? 'block' : 'none'}> <img src='/icons/round_plus_button.svg'/> </styled.NotScheduledWrap>
          </div>
        </div>
      );
    }
  }
}

const getDefaultLocationGroup = (channels) => {
    const locationChannel = channels.filter((channel) => {
        return channel.channel_type == 'location_feed';
    });
    if( locationChannel.length > 0 ){
        return locationChannel[0];
    }
    return null;
}

const textForManagedApplicant = (applicant) => {
    if( applicant == null ){ return ''; }
    const status = applicant?.status;
    if( status == 'picked' ){
        return applicant?.user?.first_name + ' is approved'
    }else if ( status == 'denied' ){
        return applicant?.user?.first_name + ' was denied' 
    }else{
        return ''
    }
}

const statusTagForShiftDetailHeader = (shift, selectedApplicant) => {
    if( shift == null ) { return '' }
    if( shift.name == 'open_shift' ) {
        return statusTagForOpenShiftCard(shift);
    }else if ( shift.name == 'shift_vto' ) {
        return statusTagForVTOCard(shift);
    }else if ( shift.name == 'shift' ) {
        return statusTagForTeamShiftDetailHeader(shift, selectedApplicant);
    }else{
        return null;
    }
}

const statusTagForOpenShiftCard = (shiftObject) => {
    const type = statusTagTypeForBulkShiftCard(shiftObject);
    return _textForStatusTag(type);
}

const statusTagForVTOCard = (shiftObject) => {
    const type = statusTagTypeForBulkShiftCard(shiftObject);
    return _textForStatusTag(type);
}

const statusTagTypeForBulkShiftCard = (shiftObject) => {
    if ( shiftObject == null) {return '';}
    if( shiftObject.name == 'open_shift' || shiftObject.name == 'shift_vto' ) {
        if( shiftObject.parent_card == true ) {
            if( shiftObject.trade_status !== 'unpublished_posted' ) {
                if ( hasPendingApplicants(shiftObject) == true ){
                    return constants.detailStatusTag.pending;
                }else if ( areAllSlotsFilled(shiftObject) == true ){
                    return constants.detailStatusTag.approved;
                }else{
                    return constants.detailStatusTag.posted;
                }
            }
        }else{
            if ( shiftObject.trade_status !== 'unpublished_posted' && shiftObject.parent_card == true ){
                return constants.detailStatusTag.posted;
            }else if ( shiftObject.trade_status == 'approved' && shiftObject.child_card == true){
                return constants.detailStatusTag.approved; 
            }else{
                return constants.detailStatusTag.none;
            }
        }
    }else{
        return constants.detailStatusTag.none;
    }
}

const statusTagForTeamShiftDetailHeader = (shift, selectedApplicant) => {
    const type = statusTagTypeForTeamShiftDetailHeader(shift, selectedApplicant);
    return _textForStatusTag(type);
}

const statusTagTypeForTeamShiftDetailHeader = (shift, selectedApplicant) => {
    if( shift == null ) { return '' }
    if( shift.name == 'shift' ) {
        if( shift.trade_status == 'covered' || shift.trade_status == 'approved' ){
            return constants.detailStatusTag.approved;
        }else if ( shift.trade_status == 'posted' || shift.trade_status == 'pending' ){
            if( shift.current_applicants_pending_user_ids.length == 0 && shift.current_applicants_picked_user_ids.length == 0 ){
                return constants.detailStatusTag.posted;
            }else if( selectedApplicant != null ){
                if( selectedApplicant.status == 'picked' ){
                    return constants.detailStatusTag.approved;
                }else if ( selectedApplicant.status == 'applied' ){
                    return constants.detailStatusTag.pending;
                }
            }
        }
    }
    return constants.detailStatusTag.none;
}

const _textForStatusTag = (tagType) => {
    if( tagType == constants.detailStatusTag.approved){
        return approvedText();
    }else if ( tagType == constants.detailStatusTag.pending){
        return pendingText();
    }else if ( tagType == constants.detailStatusTag.posted){
        return postedText();
    }else{
        return null;
    }
}

const _classNameForStatusTag = (tagType) => {
    if( tagType == constants.detailStatusTag.approved){
        return 'tag-approved';  
    }else if ( tagType == constants.detailStatusTag.pending){
        return 'tag-pending';
    }else if ( tagType == constants.detailStatusTag.posted){
        return 'tag-posted';
    }else{
        return '';
    }
}

const statusTagClassNameForShiftDetailHeader = (shift, selectedApplicant) => {
    if( shift == null ) { return '' }
    if( shift.name == 'open_shift' || shift.name == 'shift_vto' ) {
        const type = statusTagTypeForBulkShiftCard(shift)
        return _classNameForStatusTag(type);
    }else if ( shift.name == 'shift' ) {
        const type = statusTagTypeForTeamShiftDetailHeader(shift, selectedApplicant);
        return _classNameForStatusTag(type);
    }else{
        return null;
    }
}


// approved open shift, posted team shift, team shift with everyone denied
const singleUserToDisplay = (shift, allUsers, applicant) => {
    if ( shift.name == 'shift' ){
        return getPoster(shift, allUsers);
    }else if ( shift.name == 'open_shift' || shift.name == 'shift_vto' ){
        if( shift.trade_status == 'approved' || shift.trade_status == 'covered' || shift.current_applicant_status == 'picked' ){
            return getTaker(shift, allUsers);
        }else{
            if (applicant && applicant.user_id) {
                const applicantUser = getUserFromId(applicant.user_id, allUsers);
                return applicantUser;
            }
            return getPoster(shift, allUsers);
        }
    }
    return null;
}

const leftUserToDisplay = (shift, allUsers) => {
    if( shift.name == 'shift' ){
        return getPoster(shift, allUsers);
    }
    return null;
}

const rightUserToDisplay = (shift, allUsers, selectedApplicant) => {
    if( selectedApplicant == null ) { return null; }
    if( shift.name == 'shift' ) {
        if( shift.trade_status == 'approved' || shift.trade_status == 'covered' ){
            return getTaker(shift, allUsers);
        }else{
            return  getUserFromId(selectedApplicant.user_id, allUsers);
        }
    }
    return null;
}

const featuredUserForShiftDetailHeader = (shift, allUsers) => {
    if( shift.name == 'open_shift' || shift.name == 'shift_vto' || shift.name == 'shift' ){
        if( shift.trade_status == 'approved' || shift.trade_status == 'covered' ){
            const taker = getTaker(shift, allUsers);
            console.log(JSON.stringify(taker));
            return taker;
        }else{
            return getPoster(shift, allUsers);
        }
    }
    return null;
}

const sloganForShiftDetailHeader = (shift, allUsers) => {
    if( shift == null ) { return '' }
    if( shift.name == 'open_shift' ) {
        return 'has been approved to cover this open shift';
    }else if ( shift.name == 'shift_vto' ) {
        return 'has been approved to take VTO';
    }else if ( shift.name == 'shift' ) {
        if( shift.trade_status == 'approved' || shift.trade_status == 'covered' ){
            const taker = getPoster(shift, allUsers);
            return `has been approved to cover ${taker.first_name}'s shift`;
        }else{
            return 'is looking for someone to cover this shift';
        }
    }else{
        return '';
    }
}

const borderColorFromRoleTagColor = (roleTagColor) => {
    return '#'+roleTagColor;
}

const backgroundColorFromRoleTagColor = (roleTagColor) => {
    return '#'+roleTagColor+'1E';
}

const getRoleNameOrJobTitle = (roles, jobTitle) => {
    if( roles && roles?.length > 0 && roles[0] !== null){
        return roles[0].name;
    }else{
        return jobTitle;
    }
}

export default {
    getDefaultLocationGroup,
    deleteText,
    copyText,
    saveText,
    cancelText,
    addShiftString,
    groupPlaceholderText,
    userAvatarPlaceholder,
    createShiftOnText,
    applicantAvatar,
    getApplicantName,
    getApplicantPosition,
    getApplicantNameAndPosition,
   cardClassNameForShift,
   shouldShowStatusTag,
   tagTextForShiftCard,
   shouldShowPosterAvatar,
   shouldShowTakerAvatar,
   addShiftText, 
   viewShiftText,
   jobTitleText, 
   assignToText,
   timeText,
   applyToText,
   overnightShiftText,
   longTitleWarningText,
   posterAvatar,
   takerAvatar,
   xCoveringForYText,
   statusTagForOpenShiftCard,
   getGroupName,
   shouldShowSectionTab,
   hasAppliedForOpenShift,
   isApprovedForOpenShift, 
   getOpenShiftApplicantTagline,
   hasAppliedForVTO,
   isApprovedForVTO,
   deniedForVTO,
   pendingX,
   approvedX,
   deniedX,
   messageX,
   getUserFromId,
   getUserAvatar,
   openShiftSelectionTarget,
   vtoSelectionTarget,
   visibilityClassName,
   getPoster,
   getName,
   getUserAvatar,
   pasteShift,
   textHours,
   getTaker,
   getNameFromApplicantOrUserId,
   userShiftIsAssignedTo,
   applicantNumberText,
   getGroupId,
   getGroup,
   notScheduledCell,
   pasteShiftCell,
   addNewShiftCell,
   sendApplicantCommentText,
   getApplicantFirstName,
   textForManagedApplicant,
   cardClassNameForOpenShift,
   approvedText,
   deniedText,
   postedText,
   pendingText,
   calledOffText,
   coveredText,
   statusTagForShiftDetailHeader, 
   statusTagForTeamShiftDetailHeader,
   singleUserToDisplay,
   leftUserToDisplay,
   rightUserToDisplay,
   featuredUserForShiftDetailHeader,
   sloganForShiftDetailHeader,
   getApplicantTagline,
   statusTagClassNameForShiftDetailHeader,
   borderColorFromRoleTagColor,
   backgroundColorFromRoleTagColor,
   getRoleNameOrJobTitle,
   cardClassNameForVTO,
   statusTagForVTOCard,
   createVTOOnText,
   createTitleText,
   descriptionText,
   addObjectText,
   labelForPillTag,
   detailsText,
   deleteTitleText,
   deleteBodyText,
   pasteVTO,
};